const mediaTypes = [
	{
		path: '/community/wikigamer/media-types/list',
		name: 'community-wikigamer-media-types-list',
		component: () => import('@/views/community/wikigamer/media-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,wikigamer',
		},
	},
]

export default mediaTypes
